// eslint-disable-next-line no-shadow
enum AcquiringFeeType {
  SITE,
  POS,
}

export default AcquiringFeeType;
